import {IconSizeColorProps} from "./types";

export default function CheckIcon({
    size=20,
    color="black",
    ...props
                                  }:IconSizeColorProps) {
    return <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M5 9.99996L8.33333 13.3333L15 6.66663" stroke={color} strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round"/>
    </svg>

}